// Generated file - do not change manually!

/**
 * Defines the type of <code>ui5-table</code>.
 */
export enum TableMode {
  /**
   * Multi selection mode (more than one table row can be selected).
   */
  MultiSelect = 'MultiSelect',

  /**
   * Default mode (no selection).
   */
  None = 'None',

  /**
   * Single selection mode (only one table row can be selected).
   */
  SingleSelect = 'SingleSelect'
}
